export function getLedPriceExt(value) {
    this.generatedSku = value;

    if (!this.generatedSku) {
        return;
    }

    // Build request params with SKU and optionally the optics ID for individual optics
    const params = { 'sku': this.generatedSku };
    if (this.selectedOptics) {
        params['led_module_optics_id'] = this.selectedOptics;
    }

    axios.get('/api/plannings/get_led_price', {params: params})
        .then(response => {
            this.calculatedProductPrice = response.data;

            // if calculatedProductPrice is false (not found), disable continue button
            // Note: 0 is a valid price (placeholder until Falcana sync), so use strict comparison
            if (this.calculatedProductPrice === false) {
                this.validatedSteps = this.validatedSteps.filter(el => el !== 1);
            } else if (this.allLuminaireSelectionStepsSelected) {
                this.validatedSteps.push(1)
            }

        }).catch(error => {
            console.log(error);
            this.loading = false;
        });
}
